import DateNoTz from "./common/utils/DateNoTz";

export default {
    errorCatch: e =>
        e.response
            ? e.response.data
                ? e.response.data.outcome
                    ? e.response.data.outcome.message
                    : e.response.data.message
                : e
            : e,
    debounce: (callback, timeout, type) => {
        window[type];
        return function (e) {
            var _that = this;
            if (window[type]) {
                clearTimeout(window[type]);
            }

            if (
                type == "logout" &&
                ["/login", "/register"].includes(window.app.$route.fullPath)
            ) {
                return;
            } else if (
                type == "refresh" &&
                [
                    "/login",
                    "/register",
                    "/booking/home",
                    "/booking/home",
                    "/booking/my-profile",
                    "/booking/faq"
                ].includes(window.app.$route.fullPath)
            ) {
                return;
            }

            window[type] = setTimeout(function () {
                callback.call(_that, e);
            }, timeout);
        };
    },
    phoneNumberValidation: event => {
        // If char not a number nor a backspace, plus, and minus
        // then don't access input
        if (
            !/^[0-9 _]+$/i.test(event.key) &&
            event.key !== "Backspace" &&
            event.key !== "Tab"
        ) {
            event.preventDefault();
            event.stopPropagation();
        }
    },
    lettersOnlyValidation: event => {
        // If char, proceed
        // then don't access input
        if (
            !/^[a-zA-Z- ]+$/i.test(event.key) &&
            event.key !== "Backspace" &&
            event.key !== "Tab"
        ) {
            event.preventDefault();
            event.stopPropagation();
        }
    },
    addressTransform: addresses =>
        addresses.map(a => {
            a["displayName"] =
                a.streetNumber +
                " " +
                a.streetName +
                " " +
                a.suburb +
                " " +
                a.postCode;
            return a;
        }),
    Payment: {
        Free: 1,
        Paid: 2
    },
    Option: {
        True: 1,
        False: 2,
        On: 1,
        Off: 0
    },
    Variation: {
        Single: 1,
        Multiple: 2
    },
    UserType: {
        resident: 1,
        cso: 2
    },
    DisplayCalendarSetting: {
        HIDE: 0,
        SHOW: 1
    },
    DisplayPreparationNote: {
        HIDE: 0,
        SHOW: 1
    },
    DisplayTextOfServiceGroup: {
        bulkBin: {
            dateSubheader:
                "Please use the calendar below to select the date that you would like your bulk bin to be delivered."
        },
        mattress: {
            dateSubheader:
                "Please use the calendar below to select the date that you would like your mattress(es) to be collected."
        },
        whiteGoods: {
            dateSubheader:
                "Please use the calendar below to select the date that you would like your white good(s) to be collected."
        },
        default: {
            dateSubheader:
                "Please use the calendar below to select the date that you would like your hard waste to be collected."
        }
    },
    FakeStreams: {
        "1coast": {
            "Bulk kerbside collection": {
                dependencyName: "general household",
                fakeStream: {
                    isFakeStream: true,
                    api_value: "fridge",
                    has_variation: 0,
                    is_cso: 1,
                    is_res: 1,
                    max_per_collection: 100,
                    max_per_collection_defaulted: true,
                    waste_stream_name: "Fridge",
                    waste_stream_setting_id: "fake-01"
                }
            }
        }
    },
    // --- Costant Values for Council Identification
    PORTALS: {
        BAYSWATER: "bayswater",
        CITYOFPAE: "cityofpae",
        MARION: "marion",
        CARDINIA: "cardinia",
        KALAMUNDA: "kalamunda",
        ADELAIDE: "adelaide",
        HILLSHIRE: "thehills",
        BRIMBANK: "brimbank",
        MOONEEVALLEY: "mooneevalley",
        MOONEEVALLEYBETA: "mvbeta",
        ONECOAST: "1coast",
        WHITEHORSE: "whitehorse",
        MAROONDAH: "maroondah",
        ITAPI: "itapi",
        HOBSONS: "hobsons",
        JOONDALUP: "joondalup",
        RESIDENTPORTAL: "test2",
        RP2: "rp-2",
        LOCAL: "resident-portal"
    },
    // --- Public Static Method used for identifying Councils
    getPortalName() {
        var url = window.location.href;
        for (var key in this.PORTALS) {
            if (url.indexOf(this.PORTALS[key]) > -1) {
                return this.PORTALS[key];
            }
        }
        return "default";
    },
    getUserType() {
        const data = JSON.parse(localStorage.BasicDetails);
        return data.type.substring(0, 3);
    },
    getDisplayTextOfServiceGroup(serviceGroupName) {
        serviceGroupName = serviceGroupName
            .split(" ")
            .join("")
            .toLowerCase();

        // Bayswater Specific Controls
        if (this.getPortalName() == "bayswater") {
            if (serviceGroupName.indexOf("bulkbin") > -1) {
                return this.DisplayTextOfServiceGroup.bulkBin;
            } else if (serviceGroupName.indexOf("mattress") > -1) {
                return this.DisplayTextOfServiceGroup.mattress;
            } else if (serviceGroupName.indexOf("whitegoods") > -1) {
                return this.DisplayTextOfServiceGroup.whiteGoods;
            }
        }

        return this.DisplayTextOfServiceGroup.default;
    },
    removeDuplicates: (myArr, prop) =>
        myArr.filter(
            (obj, pos, arr) =>
                arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos
        ),
    ConsolidatedProduct: {
        _isInit: false,
        _summarizeProducts: [],
        isInit: () => {
            if (!this.ConsolidatedProduct._isInit) {
                return false;
            }
            return true;
        },
        setProducts: list => {
            if (!this.ConsolidatedProduct._isInit) {
                this.ConsolidatedProduct._summarizeProducts = [...list].map(
                    product => product.price * product.qty
                );
                this.ConsolidatedProduct._isInit = true;
            }
        },
        totalAmount: () =>
            this.ConsolidatedProduct._isInit
                ? this.ConsolidatedProduct._summarizeProducts.reduce(
                    (amount, price) => amount + price
                )
                : 0
    },
    generateUuid: () => {
        const resourceString = "zyxwvutsrqonlkjihgfedcb1234567890";
        let returnString = "";
        for (let i = 0; i < 16; i++) {
            const index = Math.floor(Math.random() * resourceString.length);
            returnString += resourceString.charAt(index);
        }
        return returnString;
    },
    computeProductPrice: (product, gst, toFixed = true) => {
        const p = { ...product };
        const gstPercnetage = parseInt(gst) / 100;
        return toFixed
            ? (p.price / (1 + gstPercnetage)).toFixed(2)
            : p.price / (1 + gstPercnetage);
    },
    sumArray: (arr = []) => {
        return parseFloat(
            arr.reduce((a, b) => parseFloat(a) + parseFloat(b), 0)
        );
    },
    getProductPrice: priceObj => {
        if (
            priceObj.product_pricing_enddate &&
            new Date() > new Date(priceObj.product_pricing_enddate)
        ) {
            return priceObj.product_pricing_price2;
        }
        return (
            priceObj.product_pricing_price1 ||
            priceObj.product_pricing_price2 ||
            0
        );
    },
    reformatErrorMessage(originalMessage, errorCode, newMessage) {
        if (originalMessage && originalMessage.indexOf(errorCode) > -1) {
            return newMessage;
        } else {
            return originalMessage;
        }
    },
    scrollToTop(subject) {
        const element = document.getElementById(subject);
        if (element) {
            window.scrollTo(0, window.pageYOffset - element.offsetTop);
        }
    },
    scrollIntoView(element) {
        if (typeof element == "string") {
            element = document.getElementById(element);
        }
        element.scrollIntoView({
            behavior: "smooth"
        });
    },
    objectsGroupBy(arr, byField) {
        if (typeof arr === "undefined") return [];
        return arr.reduce((r, a) => {
            r[a[byField]] = [...(r[a[byField]] || []), a];
            return r;
        }, {});
    },
    BookingOption: {
        Single: 1,
        Multiple: 2
    },
    buildName(product) {
        const names = [];
        if (!product) {
            product = {};
        }

        if (product.isService || product.isServiceGroup) {
            return product.name;
        }

        var { productNames } = product;

        var wasteStreamName = productNames
            ? productNames.wasteStreamName
            : null;
        var variationName = productNames
            ? productNames.variationName || productNames.woiWasteName || null
            : null;
        var qty = product.qty;
        // --- Waste Stream Name
        if (wasteStreamName && !product.invalid) {
            names.push("(" + qty + ")" + wasteStreamName);
        }

        // --- waste Variation Name
        if (wasteStreamName && variationName) {
            if (!product.invalid && product.hasVariation > 0) {
                names.push("(" + variationName + ")");
            } else {
                names.push("(" + qty + ")" + variationName);
            }
        }

        return names.join(" ");
    },
    checkProductsForInvalidDependentStreams(
        bookingProductList,
        selectedServiceName
    ) {
        var invalidDependentStreams = [];

        const streamDependencyList = {
            brimbank: {
                "paid collection": [
                    {
                        requirement: "hardwaste",
                        dependent: "mattress"
                    },
                    {
                        requirement: "hardwaste",
                        dependent: "car tyres"
                    },
                    {
                        requirement: "hardwaste",
                        dependent: "truck tyres"
                    }
                ]
            },
            mvbeta: {
                "paid collection": [
                    {
                        requirement: "hardwaste",
                        dependent: "mattress"
                    }
                ]
            },
            mooneevalley: {
                "paid collection": [
                    {
                        requirement: "hardwaste",
                        dependent: "mattress"
                    }
                ]
            },
            whitehorse: {
                "paid collection": [
                    {
                        requirement: "hardwaste",
                        dependent: "bundledgreenwaste(upto3cubicmetreswithotherhardwaste)",
                    },
                ]
            },
            maroondah: {
                "paid hard rubbish collection": [
                    {
                        requirement: "hardwaste",
                        dependent: "mattresses(pleaseselecthardwasteforbedbases)",
                    },
                    {
                        requirement: "hardwaste",
                        dependent: "fridge(max1)"
                    }
                ]
            }
        };

        // --- Check for a dependency list by portal
        var portalName = this.getPortalName();
        var portalDependecy = streamDependencyList[portalName];
        if (!portalDependecy) {
            return invalidDependentStreams;
        }

        // --- Check for a dependency list by service
        if (!selectedServiceName) return invalidDependentStreams;
        var serviceDependency = null;
        selectedServiceName = selectedServiceName.toLowerCase();
        for (var service in portalDependecy) {
            if (selectedServiceName.indexOf(service) > -1) {
                serviceDependency = portalDependecy[service];
            }
        }
        if (!serviceDependency) {
            return invalidDependentStreams;
        }

        // --- Create a list of names of products in the cart to check
        var bookingProductListNames = bookingProductList.map(bookingProduct => {
            var productNames = bookingProduct.productNames || {};
            var name;
            // --- If level 1
            if (typeof productNames.parentWasteStreamName == "string") {
                name = productNames.parentWasteStreamName;
            } else if (typeof productNames.displayName == "string") {
                name = productNames.displayName;
            }
            bookingProduct.name =
                typeof name == "string" ? name.toLowerCase().replace(/ /g, "") : "";

            // --- Check for a parent stream
            bookingProduct.parentName =
                typeof bookingProduct.parent_name == "string" ? bookingProduct.parent_name.toLowerCase().replace(/ /g, "") : "";

            return bookingProduct;
        });

        // --- Remove non-qty Booking Products
        bookingProductListNames = bookingProductListNames.filter(
            product => product.qty > 0
        );

        // --- Check for any present requirement waste streams
        var dependentWasteStreams = [];
        serviceDependency.forEach(wasteStreamDependency => {
            var dependentName = wasteStreamDependency.dependent.replace(/ /g, "");
            var foundDependent = bookingProductListNames.find(product => {
                return product.name
                    ? product.name.indexOf(dependentName) > -1
                    : false;
            });
            if (foundDependent) {
                foundDependent.wasteStreamDependency = wasteStreamDependency;
                dependentWasteStreams.push(foundDependent);
            }
        });
        if (dependentWasteStreams.length <= 0) {
            return invalidDependentStreams;
        }

        // --- Check each dependent for their requirements
        dependentWasteStreams.forEach(requirement => {
            var requirementName = requirement.wasteStreamDependency.requirement
                .toLowerCase()
                .replace(/ /g, "");
            var productNames = [];
            var requirementExists = !bookingProductListNames.some(product => {
                productNames.push(product.name);
                return product.name.indexOf(requirementName) > -1 || product.parentName.indexOf(requirementName) > -1
            });

            if (portalName == 'whitehorse' && requirementName == "hardwaste" && productNames.includes("bundledgreenwaste(upto3cubicmetreswithotherhardwaste)")) {
                requirementExists = true;
            }

            //Added to check maroondah productName mattresses(pleaseselecthardwasteforbedbases)
            if (portalName == 'maroondah' && requirementName == "hardwaste" && productNames.includes("mattresses(pleaseselecthardwasteforbedbases)")) {
                requirementExists = true;
            }

            if (requirementExists) {
                invalidDependentStreams.push(requirement);
            }
        });

        return invalidDependentStreams;
    },
    getFakeStreamsOfCart(bookingProductsCart, serviceName) {
        const fakeStreamSettingList = this.FakeStreams;

        var fakeStreams = null;

        var portalName = this.getPortalName();

        var siteFakeStreamSettings = fakeStreamSettingList[portalName];

        if (!siteFakeStreamSettings) {
            return fakeStreams;
        }

        var serviceFakeStreamSettings = siteFakeStreamSettings[serviceName];
        if (!serviceFakeStreamSettings && siteFakeStreamSettings.default) {
            serviceFakeStreamSettings = siteFakeStreamSettings.default;
        }
        if (!serviceFakeStreamSettings) {
            return fakeStreams;
        }

        var isDependencyPresent = false
        var isFakeStreamPresent = false
        var dependencyName = serviceFakeStreamSettings.dependencyName.toLowerCase()
        var fakeStreamName = serviceFakeStreamSettings.fakeStream.waste_stream_name.toLowerCase()
        const productNameArr = []; //define list of waste name for checking the exist waste


        bookingProductsCart = bookingProductsCart.filter(
            product => product.qty > 0
        );

        bookingProductsCart.forEach(product => {
            var productNames;
            if (product.productNames) {
                productNames = product.productNames;
            } else if (typeof product.name == "object") {
                productNames = product.name;
            } else if (typeof product.name == "string") {
                productNames = { displayName: product.name };
            }
            var displayName = productNames.displayName || "";
            displayName =
                typeof displayName == "string" ? displayName.toLowerCase() : "";

            if (displayName.indexOf(dependencyName) > -1) {
                isDependencyPresent = true;
            } else if (displayName.indexOf(fakeStreamName) > -1) {
                isFakeStreamPresent = true;
            }
            productNameArr.push(displayName);

        });

        //Check if we do not have current dependencyName selected. then check if we have fakestream in cart -> remove fakestream
        if (productNameArr.indexOf(dependencyName) !== -1) {
        } else {
            if (isFakeStreamPresent) {
                isDependencyPresent = false;
            }
        }

        if (isDependencyPresent) {
            // Add the fake stream to fakeStreams
            var fakeStream = { ...serviceFakeStreamSettings.fakeStream }
            fakeStreams = {
                list: [fakeStream],
                purge: []
            }
        }
        else if (!isDependencyPresent) {
            // Remove the fake stream from fakeStreams
            fakeStreams = {
                list: [],
                purge: [serviceFakeStreamSettings.fakeStream]
            };
        }
        return fakeStreams;
    },
    isUserMobile() {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
            navigator.userAgent
        );
    },
    getSearchParameters() {
        var prmstr = window.location.href.split("?")[1];

        if (prmstr != null && prmstr != "") {
            var params = {};
            var prmarr = prmstr.split("&");
            for (var i = 0; i < prmarr.length; i++) {
                var tmparr = prmarr[i].split("=");
                params[tmparr[0]] = decodeURI(tmparr[1]);
            }
            return params;
        }
    },
    // To detect mobile device, we use this solution 
    // https://stackoverflow.com/a/3540295/1828473
    isMobile: () => /Android|webOS|iPhone|iPad|Mac|Macintosh|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
    convertHex(color) {
        color = color.replace('#', '')
        let r = parseInt(color.substring(0, 2), 16)
        let g = parseInt(color.substring(2, 4), 16)
        let b = parseInt(color.substring(4, 6), 16)
        let result = 'rgba(' + r + ',' + g + ',' + b + ',' + 0.75 + ')'
        return result;
    },
    detectValidBrowser: () => {
        var browser = '',
            status = false,
            message = '',
            version = 0,
            OffsetVersion = 0,
            userAgent = navigator.userAgent;

        if (
            /webOS|iPhone|iPad|iPod/i.test(navigator.userAgent)
        ) {
            browser = "Safari";
            version = userAgent.substring(OffsetVersion + 7);
            if ((OffsetVersion = userAgent.indexOf("CriOS")) != -1) {
                browser = 'Chrome';
                version = userAgent.substring(OffsetVersion + 5);
            } else if ((OffsetVersion = userAgent.indexOf("Version")) != -1) {
                version = userAgent.substring(OffsetVersion + 8);
            }
        } else if (/Android/i.test(navigator.userAgent)) {
            if (
                (OffsetVersion = userAgent.indexOf("firefox")) != -1 ||
                (OffsetVersion = userAgent.indexOf("Firefox")) != -1
            ) {
                browser = "Firefox";
                version = userAgent.substring(OffsetVersion + 8);
            } else if (
                (OffsetVersion = userAgent.indexOf("Samsung")) != -1 ||
                (OffsetVersion = userAgent.indexOf("SAMSUNG")) != -1 ||
                (OffsetVersion = userAgent.indexOf("SamsungBrowser")) != -1
            ) {
                browser = "Samsung";
                version = userAgent.substring(OffsetVersion + 7);
                if ((OffsetVersion = userAgent.indexOf("Version")) != -1)
                    version = userAgent.substring(OffsetVersion + 8);
            } else if (
                (
                    (OffsetVersion = userAgent.indexOf("chrome")) != -1 ||
                    (OffsetVersion = userAgent.indexOf("Chrome")) != -1
                ) && !!window.chrome
            ) {
                browser = 'Chrome';
                version = userAgent.substring(OffsetVersion + 7);
            }
        } else if (
            (OffsetVersion = userAgent.indexOf("edge")) != -1 ||
            (OffsetVersion = userAgent.indexOf("Edge")) != -1
        ) {
            browser = 'MSEdge';
            version = userAgent.substring(OffsetVersion + 5);
        } else if (
            (OffsetVersion = userAgent.indexOf("edg/")) != -1 ||
            (OffsetVersion = userAgent.indexOf("Edg/")) != -1
        ) {
            browser = 'Edge';
            version = userAgent.substring(OffsetVersion + 4);
        } else if (
            (OffsetVersion = userAgent.indexOf("opr")) != -1 ||
            (OffsetVersion = userAgent.indexOf("OPR")) != -1 ||
            (OffsetVersion = userAgent.indexOf("Opera")) != -1
        ) {
            browser = 'Opera';
            version = userAgent.substring(OffsetVersion + 3);
        } else if (
            (OffsetVersion = userAgent.indexOf("trident")) != -1
        ) {
            browser = "MSIE";
            version = userAgent.substring(OffsetVersion + 7);
        } else if (
            (OffsetVersion = userAgent.indexOf("firefox")) != -1 ||
            (OffsetVersion = userAgent.indexOf("Firefox")) != -1
        ) {
            browser = "Firefox";
            version = userAgent.substring(OffsetVersion + 8);
        } else if (
            (
                (OffsetVersion = userAgent.indexOf("chrome")) != -1 ||
                (OffsetVersion = userAgent.indexOf("Chrome")) != -1
            ) && !!window.chrome
        ) {
            browser = 'Chrome';
            version = userAgent.substring(OffsetVersion + 7);
        } else if (
            (OffsetVersion = userAgent.indexOf("safari")) != -1 ||
            (OffsetVersion = userAgent.indexOf("Safari")) != -1
        ) {
            browser = "Safari";
            version = userAgent.substring(OffsetVersion + 7);
            if ((OffsetVersion = userAgent.indexOf("Version")) != -1)
                version = userAgent.substring(OffsetVersion + 8);
        } else if (
            (OffsetVersion = userAgent.indexOf("Samsung")) != -1 ||
            (OffsetVersion = userAgent.indexOf("SAMSUNG")) != -1 ||
            (OffsetVersion = userAgent.indexOf("SamsungBrowser")) != -1
        ) {
            browser = "Samsung";
            version = userAgent.substring(OffsetVersion + 8);
            if ((OffsetVersion = userAgent.indexOf("Version")) != -1)
                version = userAgent.substring(OffsetVersion + 8);
        } else {
            browser = "Other";
            status = false;
        }

        version = version.split(' ')[0] || version;
        version = version.split('.').map(x => parseInt(x.replace(/^\D+/g, '')));
        var browsers = document.querySelector('meta[name="browser-support"]');
        if (browsers) {
            browsers = JSON.parse(browsers.content);
            var min_version = browsers[browser];
            message = browsers['message'] || '';
            min_version = min_version.split('.').map(x => parseInt(x));
            for (var i = 0; i < min_version.length; i++) {
                if (!min_version[i] && min_version[i] !== 0) {
                    status = true;
                    break;
                }

                if (!version[i] && version[i] !== 0) {
                    status = false;
                    break;
                }

                if (min_version[i] <= version[i]) {
                    status = true;
                }

                if (min_version[i] > version[i]) {
                    status = false;
                    break;
                }
            }
        }

        return { status, message };
    },
    getFormattedDate(date) {
        var newDate = new DateNoTz(date || new Date());
        return newDate.formatDdMonYyyy();
    },
};
